import React from "react";
import ParticlesComponent from "./../Particles/ParticlesComponent";
import myPhoto from "./myPhoto.jpg";
import { TypeAnimation } from "react-type-animation";
import { AiOutlineDownload } from "react-icons/ai";
const Home = () => {
  const urlPdf = "https://saquib-ali.web.app/CV.pdf";
  const download = (url) => {
    const fileName = url.split("/").pop();
    const aTag = document.createElement("a");
    aTag.href = url;
    aTag.setAttribute("download", fileName);
    document.body.appendChild(aTag);
    aTag.click();
    aTag.remove();
  };
  return (
    <div id="home" className="h-screen max-w-screen">
      <ParticlesComponent />
      <div className=" text-white max-w-[90%] top-[45vh] left-[12vw] pr-4 sm:top-[35%] sm:left-[15%] lg:top-[40%] lg:left-[15%] md:top-[30%] md:left-[8vw] h-[50vh] flex md:flex-row flex-col justify-evenly items-center absolute">
        <div>
          <img
            src={myPhoto}
            alt=""
            className="sm:w-[30rem] w-[20rem] sm:h-[20rem] h-[15rem] rounded-[10rem] shadow-xl shadow-blue-400 hover:rounded-3xl duration-[3s] ease-in-out md:hover:scale-[1.2]"
          />
        </div>
        <div className="flex flex-col md:w-[50vw] lg:w-auto ml-[5vw] md:ml-[7vw] lg:ml-[10vw] mt-16 ">
          <h1 className="sm:text-4xl text-2xl tracking-tight leading-loose">
            Hey I am Saquib{" "}
          </h1>
          <h2 className="sm:text-5xl text-2xl tracking-tight leading-loose mt-5 text-red-400 font-extrabold">
            <span className="text-white font-thin">A </span>
            <TypeAnimation
              sequence={[
                2000,
                "Web Developer",
                2000,
                "Gamer",
                2000,
                "Footballer",
                2000,
              ]}
              wrapper="span"
              speed={250}
              cursor={true}
              repeat={Infinity}
            />
          </h2>
          <a href="#project">
            <button className="h-16 w-48 ml-0 sm:ml-8 md:ml-6 mt-6 text-lg hover:cursor-pointer transition-all duration-500 hover:-translate-y-1 hover:scale-[1.1] bg-gradient-to-r from-cyan-400 to-blue-600 shadow-lg shadow-blue-400 rounded-xl">
              See My Projects
            </button>
          </a>
          <button
            onClick={() => {
              download(urlPdf);
            }}
            className="mt-6 flex justify-between w-[6rem] text-4xl "
          >
            <p>CV:</p>{" "}
            <AiOutlineDownload className="mt-1 hover:text-red-300 duration-300 active:scale-[0.9] hover:-translate-y-1 hover:scale-[1.2]" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Home;
